<template>
  <base-popup
      :popup-model="show"
      title="Merged Invoice links"
      :valid="!valid"
      :is-overlay="isOverlay"
      :width="50"
      :show-save-button="false"
      @onCancelButtonClick="closeFilesPopupHandler"
  >
    <div class="font-weight-bold mb-2 mt-2">
      Payment Information
    </div>
    <v-card>
      <v-card-text>
        <v-simple-table>
          <template v-slot:default>
            <tbody>
              <tr>
                <td>Payment Status</td>
                <td>
                  <g-payment-status-chip v-if="currentItem.paymentStatus === 100"/>
                  <g-payment-status-chip v-else-if="currentItem.paymentStatus === 200" color="green" text="Paid"/>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
    <div class="font-weight-bold mb-2 mt-5">
      Live Links
    </div>
    <template v-for="(detail, key) in details.merged_invoice_details">
      <br>
      <v-data-table
          :headers="headers"
          :items="detail.invoice_details.invoice_detail"
          hide-default-header
          hide-default-footer
          disable-pagination
          class="elevation-1 invoice-details"
      >
        <template v-slot:item.site="{item}">
          <v-chip color="primary" class="mt-1" v-if="item.site && item.site.site_url">
            {{item.site.site_url}}
          </v-chip>
          <v-chip color="primary" class="mt-1" v-else>
            {{item.customEntityName}}
          </v-chip>
          <br>
          <span>Invoice No: {{detail.invoice_details.invoiceNo}}, Email: {{detail.invoice_details.email}}</span>
          <v-simple-table dense v-if="currentItem.billingType === 'Link Insert'">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left">
                  Anchor
                </th>
                <th class="text-left">
                  URL
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-if="item.anchorText1">
                <td>{{item.anchorText1}}</td>
                <td>{{item.url1}}</td>
              </tr>
              <tr v-if="item.anchorText2">
                <td>{{item.anchorText2}}</td>
                <td>{{item.url2}}</td>
              </tr>
              <tr v-if="item.anchorText3">
                <td>{{item.anchorText3}}</td>
                <td>{{item.url4}}</td>
              </tr>
              <tr v-if="item.anchorText5">
                <td>{{item.anchorText5}}</td>
                <td>{{item.url5}}</td>
              </tr>
              <tr v-if="item.anchorText6">
                <td>{{item.anchorText6}}</td>
                <td>{{item.url6}}</td>
              </tr>
              <tr v-if="item.anchorText7">
                <td>{{item.anchorText7}}</td>
                <td>{{item.url7}}</td>
              </tr>
              <tr v-if="item.anchorText8">
                <td>{{item.anchorText8}}</td>
                <td>{{item.url8}}</td>
              </tr>
              <tr v-if="item.anchorText9">
                <td>{{item.anchorText9}}</td>
                <td>{{item.url9}}</td>
              </tr>
              <tr v-if="item.anchorText10">
                <td>{{item.anchorText10}}</td>
                <td>{{item.url10}}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
          <br>
          <a @click.prevent.stop="liveLinkHandler(item.liveLink)" class="link-text">{{item.liveLink}}</a>
        </template>
        <template v-slot:item.total="{item}" class="column-vr-align">
          ${{item.total}}
        </template>
        <template v-slot:body.append>
          <tr>
            <td style="text-align: right"><h4>Sub Total</h4></td>
            <td style="text-align: right">${{getAmount(detail)}} </td>
          </tr>
          <tr>
            <td style="text-align: right"><h4>Discount</h4></td>
            <td style="text-align: right">${{getDiscount(detail)}} </td>
          </tr>
          <tr>
            <td style="text-align: right"><h4>Grand Total</h4></td>
            <td style="text-align: right">${{getTotal(detail)}} </td>
          </tr>
        </template>
      </v-data-table>
    </template>
    <div class="font-weight-bold mb-2 mt-5">
      Email Message
    </div>
    <v-spacer/>
    <v-card>
      <v-card-text id="myInput">
        <p>
          {{ getTitle(mailTemplate.title) }}<br><br>
          {{ mailTemplate.liveLinkText }}: {{getRefLink(currentItem.mergedNo)}}<br>
          <strong>{{ mailTemplate.stepTitle }}</strong><br><br>

          <span v-for="item in mailTemplate.steps" :key="item">{{item}}<br></span>
        </p>
      </v-card-text>
    </v-card>
  </base-popup>
</template>

<script>
import BasePopup from "./BasePopup";
import Popup from "../mixins/Popup";
import mailTemplate from "../../json/mailTemplate.json"
import GPaymentStatusChip from "@/components/GPaymentStatusChip";
import MergedInvoice from "@/services/MergedInvoice";
export default {
  name: "MergedLinkPopup",
  mixins: [Popup],
  components: {GPaymentStatusChip, BasePopup},
  data() {
    return {
      selectedItem: 0,
      mailTemplate: mailTemplate,
      details: {},
      headers: [
        {
          text: 'Site Link',
          value: 'site'
        },
        {
          text: 'Total',
          value: 'total',
          align: 'right'
        }
      ]
    }
  },
  watch: {
    currentItem: {
      handler() {
        this.getLiveLinkDetails();
      },
      deep: true
    }
  },
  methods: {
    closeFilesPopupHandler() {
      this.$emit('closePopupHandler');
    },
    liveLinkHandler(site) {
      window.open(site, '_blank');
    },
    getRefLink(refcode) {
      const api = process.env.VUE_APP_BASE_URL;
      return `${api}/payment?refno=${refcode}`;
    },
    getTitle(title) {
      let ids = [];
      if(!this.currentItem.merged_invoice_details) {
        return title.replaceAll('type', '');
      }

      this.currentItem.merged_invoice_details.forEach((item) => {
        ids.push(item.invoice_details.invoiceNo)
      })
      return title.replaceAll('type', `Invoice No.: ${ids.toString()}`);
    },
    getAmount(item) {
      return item.invoice_details.amount;
    },
    getDiscount(item) {
      return item.invoice_details.discount;
    },
    getTotal(item) {
      return item.invoice_details.totalAmount;
    },
    async getLiveLinkDetails() {
      this.details = {};
      if (!this.currentItem.id) return;
      this.isOverlay = true;
      let {data} = await MergedInvoice.getLiveLinkDetails({id: this.currentItem.id});
      if(data) {
        this.details = data;
      }
      this.isOverlay = false;
    }
  }
}
</script>

<style lang="scss">
.link-text {
  color: #1976d2;
  padding: 3px 0;
  font-size: 12px;
}
.invoice-details .v-data-table__wrapper table tbody tr{
  vertical-align: bottom !important;
}
</style>